export default __webpack_public_path__ + "static/form-multiple-action-buttons-do-da285b5583d5dc7e5762f89a0160aba6871f69050ee7adfefcdbb330ef171f03.png";